import React, { Component } from 'react'
import { Route, Link, BrowserRouter as Router } from "react-router-dom"
import {Card, profileName, pImage} from './Card';
import RateProfile from './RateProfile'


export let profileName1 = '';
export let pImage1 = '';



class RateButton extends React.Component{
		constructor() {
    super();
    this.state = {
      user: {
        id: '',
        name:''

      }
    }
  }

	render(){
		const { name, id } = this.state;
		profileName1 = profileName;
		pImage1 = pImage;
	return (
			<div className="">
			            

              <Link
                to={`/rateprofile`}
                className="b ph3 pv2 input-reset ba b--black bg-transparent grow pointer f6 dib"
              >Rate Me</Link>
            </div>
		);

	}
}

export default  RateButton;